
import React, { useState, useEffect } from "react";
import { 
  Row, Col, Card, CardBody, CardHeader, Label, Input, Button, Container
} from 'reactstrap';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { api } from "../../../config";
import { fetchComAuth, fetchComAuthJson } from '../../../common/api';
import Loader from "../../../Components/Common/Loader";
import Select from "react-select";

const CadastroEspacoRota = ({ feiraId: propFeiraId, espacoId: propEspacoId, isModal = false, onSaveSuccess}) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const feiraId = propFeiraId || params.feiraId;
    const espacoId = propEspacoId || params.espacoId;

    const isEdit = espacoId && espacoId !== 'novo';
    const [isLoading, setIsLoading] = useState(false);
    
    const [tiposEspacoFeira, setTiposEspacoFeira] = useState([]);
    const [tiposEspacoOptions, setTiposEspacoOptions] = useState([]);
    const [pavilhaoFeira, setPavilhaoFeira] = useState([]);
    const [expositoresFeiraOptions, setExpositoresFeiraOptions] = useState([]);
    const [expositoresFeira, setExpositoresFeira] = useState([]);
    const [selectedExpositor, setSelectedExpositor] = useState([]);
    const [permiteLocacaoAtual, setPermiteLocacaoAtual] = useState(false);
    const [pavilhaoPendente, setPavilhaoPendente] = useState(null);
    
    const [formData, setFormData] = useState({
        nome: "",
        tipo_espaco_id: "",
        pavilhao_id: "",
        expositor_id: ""
    });

    const handleVoltar = () => {
        if (isModal) {
            if (onSaveSuccess) onSaveSuccess(); 
            return;
        }

        if (location.state?.fromFeira) {
            navigate(`/feira-cadastro/${feiraId}`, { state: { topBorderTab: '3', activeTabRotas: "8" } });
            return;
        }

        navigate(`/lista-espacos-rota`); 
    };
    
    useEffect(() => {
        const loadAuxData = async () => {
            try {
                const [resTipos, resFeiraTipos, resPav, resExpositor] = await Promise.all([
                    fetchComAuth(`${api.API_URL}/tipo-espaco`),
                    fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`),
                    fetchComAuth(`${api.API_URL}/feira/pavilhao_feira/${feiraId}`),
                    fetchComAuth(`${api.API_URL}/feiraExpositor/${feiraId}`)
                ]);

                setTiposEspacoOptions((await resTipos.json()).data || []);
                setTiposEspacoFeira((await resFeiraTipos.json()).data || []);
                setPavilhaoFeira((await resPav.json()).data || []);
                const data = await resExpositor.json();
                setExpositoresFeira((data.data || []));
         
                const opcoesFormatadas = data.data.map(expositor => {
                    return {
                    value: expositor.id,
                    label: expositor.nome
                    };
                });
                setExpositoresFeiraOptions(opcoesFormatadas);

            } catch (err) {
                console.error("Erro ao carregar dados auxiliares", err);
                toast.error("Erro ao carregar opções.");
            }
        };
        if (feiraId) loadAuxData();
    }, [feiraId]);

    useEffect(() => {
        
        if (isEdit) { 
            const loadSpace = async () => {
                setIsLoading(true);
                try {
                    let space = null;

                    if (!space || !space.id) {
                        const response = await fetchComAuth(`${api.API_URL}/rota/estandes/${feiraId}?refresh=1`);
                        const json = await response.json();
                        space = json.data.find(s => s.id.toString() === espacoId.toString());
                    }

                    if (space) {
                        
                        setFormData({
                            nome: space.nome || "",
                            tipo_espaco_id: space.tipo_espaco_id?.toString() || "",
                            pavilhao_id: space.pavilhao_id || "",
                            expositor_id: space.expositor_id || null
                        });
                    } else {
                        toast.error("Espaço não encontrado.");
                        handleVoltar();
                    }
                } catch (err) {
                    console.error(err);
                    toast.error("Erro ao carregar dados do espaço.");
                } finally {
                    setIsLoading(false);
                }
            };
            loadSpace();
        }
    }, [isEdit, espacoId, feiraId]);

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if(!formData.nome) return toast.error("Nome é obrigatório");
        if(!formData.tipo_espaco_id) return toast.error("Tipo de Espaço é obrigatório");
        
        setIsLoading(true);
        try {
            
            const payload = {
                feira_id: feiraId,
                tipo_espaco_id: formData.tipo_espaco_id,
                nome: formData.nome,
                pavilhao_id: formData.pavilhao_id,
                expositor_id: selectedExpositor ? selectedExpositor.value : null
            };

            const url = isEdit ? `${api.API_URL}/rota/estande/${espacoId}` : `${api.API_URL}/rota/estande`;
            const method = isEdit ? 'PUT' : 'POST';

            const response = await fetchComAuthJson(url, { method, body: JSON.stringify(payload) });
            
            if(response.ok) {
                toast.success(`Espaço ${isEdit ? 'atualizado' : 'criado'} com sucesso!`);
                if (isModal && onSaveSuccess) {
                    onSaveSuccess(); 
                } else {
                    handleVoltar();
                }
            }


        } catch (err) {
            
            console.error(err);
            toast.error("Erro ao salvar dados.");
        } finally {
            setIsLoading(false);
        }
    };

    const pavilhaoSelecionado = pavilhaoFeira.find(
        (p) => p.id.toString() === formData.pavilhao_id?.toString()
    );

    return (
        <React.Fragment>
            <div className={isModal ? "" : "page-content"}>
                <Container fluid>
                    {!isModal && <BreadCrumb title={isEdit ? "Editar Espaço" : "Novo Espaço"} pageTitle="Espaços" />}
                    <Row>
                        <Col lg={12}>
                            <Card className={isModal ? "border-0 shadow-none mb-0" : ""}>
                                {!isModal && (
                                    <CardHeader>
                                        <h5 className="card-title mb-0">Dados do Espaço</h5>
                                        <div className="d-flex justify-content-end gap-2">
                                            <Button color="light" onClick={handleVoltar}>Voltar</Button>
                                        </div>
                                    </CardHeader>
                                )}
                                <CardBody>
                                    {isLoading ? <Loader /> : (
                                        <form onSubmit={handleSubmit}>
                                            <Row>
                                                <Col md={3} className="mb-3">
                                                    <Label>Nome do Espaço</Label>
                                                    <Input name="nome" value={formData.nome} onChange={handleInputChange} required />
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label>Tipo de Espaço</Label>
                                                    <Input type="select" name="tipo_espaco_id" value={formData.tipo_espaco_id} onChange={handleInputChange} required>
                                                        <option value="">Selecione...</option>
                                                        {tiposEspacoFeira.map(t => (
                                                            <option key={t.tipo_espaco_id} value={t.tipo_espaco_id}>
                                                                {tiposEspacoOptions.find(opt => opt.id === t.tipo_espaco_id)?.nome || t.tipo_espaco_id}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label>Pavilhão</Label>
                                                  
                                                    <select
                                                        name="pavilhao_id"
                                                        id="pavilhao-select-input"
                                                        value={formData.pavilhao_id || ''}
                                                        onChange={handleInputChange} 
                                                        style={{ width: "100%", padding: "0.5rem" }}
                                                        className="form-select" 
                                                        >
                                                        <option value="">Selecione um pavilhão</option>
                                                        {pavilhaoFeira.map(pavilhao => (
                                                            <option key={pavilhao.id} value={pavilhao.id}>
                                                            {pavilhao.nome}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label className="form-label">Expositor</Label>
                                                    <Select value={selectedExpositor} onChange={setSelectedExpositor} options={expositoresFeiraOptions} placeholder="Selecione..."/>
                                                </Col>
                                            </Row>

                                            <div className="d-flex justify-content-end gap-2">
                                                {!isModal && (
                                                    <Button color="light" onClick={handleVoltar}>Voltar</Button>
                                                )}
                                                <Button color="success" type="submit">Salvar Espaço</Button>
                                            </div>
                                        </form>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    );
};

export default CadastroEspacoRota;